/* no-unused-vars */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row,SendRemainderButton,DeleteUserButton,ControlButtonsBar, Layout, ButtonsContainer,HoverableDiv } from './styles';
// import { ImageUrl } from "../../utils/constants";
import {  RowCardPeopleView, InactiveTabsHeader } from './styles';
import { connect } from 'react-redux';  
import { withTranslation } from 'react-i18next';
import ParticipantLocationPopup from '../NewEmployeePopupV2/participantsLocation';
// import {getNotRegisteredUsersList, sendRemainderByIds} from "../../redux/constants/apiConstants";
import {sendRemainderByIds, deleteInactiveUserById} from "../../redux/constants/apiConstants";
import { BASE_URL } from "../../utils/config";
import { toast } from "react-toastify";
import { CalendarHeader, CalendarWrapper, ConfirmVisitText, StyledModal, ButtonContainer,/*ButtonContainerV1,*/ButtonV2 } from '../PeopleHomeV2/ManageBuddies/styles';
import LazyImage from '../common/LazyImage/LazyImage';
import _ from 'lodash';
import { /*ArchiveIcon,*/ RadioCheckIcon, RecognitionTickIcon, RecognitionWarningIcon,/* WarningIcon */} from '../../utils/icons';
// import deletePopupBranding from '../DeletePostPopup/deletePopupBranding';
import CommonModal from '../common/CommonModal/CommonModal';
import { ImageUrl } from '../../utils/constants';


class InactiveUsersListView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: null,
      initiativeId: null,
      initiativeName: null,
      inactiveUsersList: this.props.inactiveUsersList,
      locationData:this.props.locationData,
      departmentData:this.props.departmentData,
      selectedParticipant: [],
      deleteTeamIDS:[],
      ReminderEmployess: null,
      showNote: false,
      selectPage:0,
      showSelectPage : false,
      selectAll: 0,
      showPopup : false,
      showDeleteUserPopup: false,
      showSelectAll : false,
      isButtonEnabled: false,
    };
  }

  

  componentDidMount() {
    //const { employeeList } = this.props;
    //this.fetchInactiveUsersList(plp.companyId);
    //this.setState({ inactiveUsersList:this.props.inactiveUsersList});
    this.handleShowSelectAllButton(this.props);
  }

  handleShowSelectAllButton(data){
    window.console.log('inside handle',data);
  }

  onEnterMouse = (uid, id, name) => {
    this.setState({
      userId: uid,
      initiativeId: id,
      initiativeName: name,
    });
  };

  onLeaveMouse = () => {
    this.setState({
      userId: null,
      initiativeId: null,
    });
  };

  activeTick = (index) => {
    const selectedId = [...this.state.selectedParticipant];
    let objIndex = selectedId.findIndex((id) => id == index);
    objIndex == -1 ? selectedId.push(index) : selectedId.splice(objIndex, 1);

    let tempCount = 0;

    this.props.inactiveUsersList.map((employee) => employee.days_left && tempCount++)

    if(this.props.inactiveUsersList.length == (selectedId.length+tempCount)){
      this.setState({
        selectAll: 1,
        selectPage: 0,
        isButtonEnabled: true
      });
    }
    else if (selectedId.length > 0) {
      this.setState({
        selectAll: 2,
        selectPage: 0,
        isButtonEnabled: true,
      });
    }
    else{
      this.setState({
        selectAll: 0,
        selectPage: 0,
        isButtonEnabled: false,
      });
    }
    this.setState({
      selectedParticipant: selectedId,
    },() => {
      this.props.updateParentState({
        selectAll: this.state.selectAll,
        selectedParticipant: this.state.selectedParticipant,
      });
    });
    // localStorage.setItem("selectedEmployeeList", JSON.stringify(selectedArray))
  };

  handelSelectAll = (isSelected) => {
    // const { inactiveUsersList, updateParentState } = this.props;
    this.setState({
      selectAll: isSelected ? 0 : 1,
      selectPage: 0,
      isButtonEnabled: !isSelected,
    });
    let allUserIds = [];
    if (this.state.selectAll === 0) {
      this.props.inactiveUsersList && this.props.inactiveUsersList.map((employee) => {
        allUserIds.push(employee.id);
        // if(!employee.days_left){
        //   allUserIds.push(employee.id);
        // }
       
      });
    }
    this.setState({
      selectedParticipant: allUserIds,
    },() => {
      this.props.updateParentState({
        selectAll: this.state.selectAll,
        selectedParticipant: this.state.selectedParticipant,
      });
    } );
  };

  handelSelectPage= (isSelected) => {
    this.setState({
      selectPage: isSelected ? 0 : 1,
      selectAll: 0,
      isButtonEnabled: !isSelected && !this.props.daysLeft,
    });
    let currentPageUserIds = [];
    if (this.state.selectPage === 0) {
      if(this.props.inactiveUsersList && this.props.inactiveUsersList.length > 0 ) {
        this.props.inactiveUsersList.map((employee) => {
          if(!employee.days_left){
            currentPageUserIds.push(employee.id);
          }
        });
      }
    }
    this.setState({
      selectedParticipant: currentPageUserIds,
    });
  };

  

  handleSendReminder = (participants)=>{
    this.sendReminderApiCall(participants);
    // this.setState(
    //   {
    //     showPopup : true
    //   },
    //   () => {
    //     this.sendReminderApiCall(participants);
    //   }
    // );
  }

  sendReminderApiCall = async (participants) => {
    const AuthToken = localStorage.getItem("AUTH_TOKEN");
    let payload = {
      company_id: this.props.plp.companyId,
      user_ids: this.state.selectAll===1 && !this.props.searchText && !this.props.locationText && !this.props.departmentText ? [] : participants,
      sent_req_to_all: this.state.selectAll===1 && !this.props.searchText && !this.props.locationText && !this.props.departmentText ? true : false
    };
    let url = BASE_URL + sendRemainderByIds;
    await fetch(url, {
      method: "POST",
      headers: {
        AUTHTOKEN: AuthToken,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials:'include',
      withCredentials: true,
      body: JSON.stringify(payload),
    })
      .then((res) => {
        res
          .json()
          .then((data) => {
            if (data.data.success_count) {
              this.setState({ ReminderEmployess: data.data.success_count , showPopup : true} );
            } else {
              this.setState({ ReminderEmployess: 0, showPopup : true });
            }
          })
          .catch((error) => {
            toast.error(error.message);
          });
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  deleteInactiveUser = async (participants) => {
    const AuthToken = localStorage.getItem("AUTH_TOKEN");
    let payload = {
      company_id: this.props.plp.companyId,
      user_ids: this.state.selectAll=== 1 && !this.props.searchText && !this.props.locationText && !this.props.departmentText ? [] : participants,
      sent_req_to_all: this.state.selectAll=== 1 && !this.props.searchText && !this.props.locationText && !this.props.departmentText ? true : false
    };
    let url = BASE_URL + deleteInactiveUserById;
    await fetch(url, {
      method: "POST",
      headers: {
        AUTHTOKEN: AuthToken,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials:'include',
      withCredentials: true,
      body: JSON.stringify(payload),
    })
      .then((res) => {
        res
          .json()
          .then((data) => {

            if(data.status === "success"){
              this.props.fetchInactiveUsersList();
              toast.success(data?.data?.message);
            }else{
              toast.error(data?.data?.message);
            }

            if (data.data.success_count) {
              // this.props.fetchInactiveUsersList();
              this.setState({ ReminderEmployess: data.data.success_count , showPopup : true, showDeleteUserPopup: false});
              // window.location.reload()
            } else {
              this.setState({ ReminderEmployess: 0, showDeleteUserPopup: false });
              // window.location.reload()
            }
            window.setTimeout(() => {
              window.location.reload();
            }, 3000); // 1 second
          })
          .catch((error) => {
            toast.error(error.message);
          });
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };


  showDeletePopup = (id) => {
    this.setState(
      {
        showDeleteUserPopup: true, deleteTeamIDS:id
      }
    );
  };

  closUserDeletePopup = () => {
    this.setState({ showDeleteUserPopup: false });
  };

  fallBack = (e) => {
    e.target.src = "/public/images/default.png";
  };
  goToPersonalProfile = (employeeId) => {
    const { history } = this.props;
    history.push(`/company/people/${employeeId}/personal-profile`);
  };

  handlePopup = (value) => {
    this.setState({showPopup : value})
    window.location.reload()
  }
  capitalizeFirstLetter = (name) => {
    if (!name) return "";
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  
  render() {
    const { showEmployeeDetails, selectedEmployee, searchAmigo, t, plp, inactiveUsersList, showAll, remainingInactiveUser, inactiveUserCount,/* isShowLocation, isShowDepartment*/} =
      this.props;
    const { selectAll,selectPage, isButtonEnabled, deleteTeamIDS,selectedParticipant } = this.state;


    // const handleInviteUsers = () => {
    //   if (selectAll === 1) {
    //     this.handleSendReminderToAllUser();
    //   } else if (selectPage === 1) {
    //     this.handleSendReminder(this.state.selectedParticipant);
    //   }
    // };
    // let uidArray = [];
    // this.state.selectedParticipant.map((obj) => {
    //   uidArray.push(obj.uid)
    // })
    return (
      <Layout style={{padding:'0',margin:'0'}}>
        <div>
          <ControlButtonsBar>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-evenly",
              }}
            >
              
              <HoverableDiv
                isColor={selectAll > 0}
                onClick={() => this.handelSelectAll(this.state.selectAll)}
              >
                {selectAll < 1 ? (
                  ""
                ) : selectAll < 2 ? (
                  <div style={{display:"flex",justifyContent:"center",alignItems:"center", position:"absolute",top:"4px",left:"4px"}}>{RadioCheckIcon()}</div>
                ) : (
                  <div style={{display:"flex",justifyContent:"center",alignItems:"center", position:"absolute",top:"4px",left:"4px"}}>{RadioCheckIcon()}</div>
                )}
              </HoverableDiv>

              <div>
                <span className="select-page">Select All</span>
              </div>
              { inactiveUserCount > 20 || remainingInactiveUser > 20  ?
                (<div style={{display:'flex',justifyContent:'center', alignItems:'center'}}><div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                  }}
                >
                  <HoverableDiv    isColor={this.state.selectPage > 0}  style={{ marginLeft: '20px'}}
                    onClick={() => this.handelSelectPage(this.state.selectPage)}
                  >
                    {selectPage < 1 ? (
                      ""
                    ) : selectPage < 2 ? (
                      <div style={{display:"flex",justifyContent:"center",alignItems:"center",position:"absolute",top:"4px",left:"4px"}}>{RadioCheckIcon()}</div>
                    ) : (
                      <div style={{display:"flex",justifyContent:"center",alignItems:"center", position:"absolute",top:"4px",left:"4px"}}>{RadioCheckIcon()}</div>
                    )}
                  </HoverableDiv>
                </div>
                <div>
                  <span className="select-page">Select Page</span>
                </div></div>):null}
            </div>
   
            <ButtonsContainer>
              {selectedParticipant.length > 0 ? (
                <span className="selectedText">
                  {`${selectAll===1 && !this.props.searchText && !this.props.locationText && !this.props.departmentText ? inactiveUserCount : selectedParticipant.length} User${selectAll===1&& inactiveUserCount >1?'s':selectedParticipant.length >1?'s':'' } Selected`}
                </span>
              ) : (
                ""
              )}
              <SendRemainderButton
                disabled={!isButtonEnabled}
                onClick={isButtonEnabled ? () => this.handleSendReminder(selectedParticipant) : null
                }
              >
              Invite Users
              </SendRemainderButton>
              <DeleteUserButton
                disabled={!isButtonEnabled}
                onClick={isButtonEnabled ? () => this.showDeletePopup(selectedParticipant): null}
              >
              Remove User
              </DeleteUserButton>
            </ButtonsContainer>
          </ControlButtonsBar>
        </div>
        <div className="notScroll" style={{ marginTop: showAll===0 ? '0px': '20px'}}>
        
          <InactiveTabsHeader inactiveUser={true}>
            
            <div className="userHeading">Users</div>
            <div className="departmentHeading">Departments</div>
            <div className="locationHeading" >Locations</div>
            <div className="emailHeading" >Email</div>
            <div className="reminderHeading">Reminder Sent</div>
          </InactiveTabsHeader>
          {!(inactiveUsersList === null) &&
           !(inactiveUsersList === undefined) &&
           inactiveUsersList.length > 0 && !_.isNull(inactiveUsersList[0]) ? (
              inactiveUsersList && inactiveUsersList.map((employee, index) => (
                <RowCardPeopleView
                  key={index}
                  onClick={() => showEmployeeDetails(employee.id)}
                  active={selectedEmployee === employee.id}
                  deleted={0}
                  inactiveUser={true}
                  isCheckedColor={selectedParticipant.includes(employee.id)}
                >
                  <div className="rowContent">
                    {/* Users: Checkbox + Name */}
                    <div className="user">
                      <div
                        className="checkbox"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.activeTick(employee.id);
                        }}
                      >
                        {selectedParticipant.includes(employee.id) && (
                          <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>{RecognitionTickIcon()}</div>
                        )}
                      </div>
                      <span className="name">
                        {employee.name ? t(this.capitalizeFirstLetter(employee.name)) : '-'}
                      </span>
                    </div>
                    {/* Departments */}
                    <div className="department">
                      {employee.department ? employee.department : '-'}
                    </div>
                    {/* Locations */}
                    <div className="location" >
                      {employee.location ? employee.location : '-'}
                    </div>
                    {/* Email */}
                    <div className="email" >
                      {employee.user_email ? t(employee.user_email) : '-'}
                    </div>
                    {/* Reminder Sent */}
                    <div className="reminderText">
                      {/* {employee.days_left !== undefined && employee.days_left !== null && employee.days_left !== 0 
                        ? `Sent ${employee.days_left} day${employee.days_left > 1 ? 's' : ''} ago`
                        : '-'} */}
                      {employee.days_left !== undefined && employee.days_left !== null && employee.days_left !== 0 
                        ? `${employee?.reminder_sent_at}`
                        : '-'}
                        
                    </div>
                  </div>
                </RowCardPeopleView>
              ))
            ) : (
              <Row disableCursor={1} align={1}>
                {t("No Employee")}
              </Row>
            )}
          {!searchAmigo && (
            <ParticipantLocationPopup
              companyId={plp.companyId}
              fetchEditLocationApi={plp.fetchEditLocationApi}
              show={plp.show}
              departmentData={plp.departmentData}
              handleShowNote={plp.handleShowNote}
              data={plp.data}
              showModalPopUp={plp.showModalPopUp}
              selectedParticipant={selectedParticipant}
              companyAuthDetails={plp.companyAuthDetails}
            />
          )}
          { this.state.showPopup &&
            <StyledModal show={this.state.showPopup} width={"485px"}>
              <CalendarHeader style={{background:'#005C87'}}>
                <div>{"Confirmation"}</div>
              </CalendarHeader>
              <CalendarWrapper padding="0 25px 25px 25px" style={{display:'flex', flexDirection:'column', justifyItems:'center'}} >
                <div style={{margin:'auto',marginTop:'25px'}}>
                  <LazyImage style={{width:'130px', height:'130px'}} src={ImageUrl + '/images/PeoplePage/thank-you-popup.png'} alt="popup image" />
                </div>
                <ConfirmVisitText style={{marginBottom:'5px'}}>{"Reminder Email Sent Successfully to"}</ConfirmVisitText>
                {selectAll===1 && !this.props.searchText && !this.props.locationText && !this.props.departmentText  ?<p style={{textAlign:'center', color:'#007AB1', fontSize:'16px', fontWeight:'500', marginBottom:'20px'}}>{`Total ${remainingInactiveUser} Employee${remainingInactiveUser >1?'s':'' }`   }</p>:
                  <p style={{textAlign:'center', color:'#007AB1', fontSize:'16px', fontWeight:'500', marginBottom:'20px'}}>{`Total ${this.state.ReminderEmployess} Employee${this.state.ReminderEmployess >1?'s':'' }`   }</p>}
                <p style={{border:'1px solid #c4c4c4', margin:'0px -25px', marginBottom:'20px'}}></p>
                <ButtonContainer style={{justifyContent:"center"}}>
                  <ButtonV2
                    background="#007AB1"
                    backgroundHover= "#005C87"
                    onClick={() => this.handlePopup(false)}
                    style={{width:'100%'}}
                  >
                    {"Thank You"}
                  </ButtonV2>
                </ButtonContainer>
              </CalendarWrapper>
            </StyledModal>
          }
          {this.state.showDeleteUserPopup  && <CommonModal
            show={this.state.showDeleteUserPopup}
            icon={RecognitionWarningIcon("#CE7841")}
            title="Remove User"
            description="Are you sure you want to remove Users profile?"
            subDescription="This action cannot be undone, and the post will be permanently removed from the system."
            onCancel={this.closUserDeletePopup}
            onConfirm={()=>this.deleteInactiveUser(deleteTeamIDS)}
            cancelText="Cancel"
            confirmButtonText="Remove Permanently"
            // buttonIcon={ArchiveIcon()}
            // modalHeight="244px"
            confirmButtonWidth="182px"
          />}

          {/* { this.state.showDeleteUserPopup &&
            <StyledModal show={this.state.showDeleteUserPopup} width={"400px"} height={"292px"}>
              <CalendarHeader deleteInactiveUser={true} style={{background:'none',borderBottom:'1px solid rgba(0, 0, 0, 0.21)'}}>
                <div>{WarningIcon()} Remove User</div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ marginRight: '10px' }}>{WarningIcon()}</div>
                  <div>Remove User</div>
                </div>
              </CalendarHeader>
              <CalendarWrapper padding="0 25px 25px 25px">
                {
                  <ConfirmVisitText deleteInactiveUser={true}>
                  Are you sure you want to remove
                  Users profile?
                  </ConfirmVisitText>
                }
                <ButtonContainerV1>
                  <ButtonV2

                    background="#007AB1"
                    backgroundHover= "#005C87"
                    width="352px"
                    height="48px"
                    onClick={() => this.closUserDeletePopup()}
                  >
                    No, Cancel
                  </ButtonV2>
                  <ButtonV2
                    border="1"
                    width="352px"
                    height="48px"
                    background="transparent"
                    color="#007AB1"
                    margin="5px 0 0 0"
                    onClick={()=>this.deleteInactiveUser(deleteTeamIDS)}
                  >
                    Yes, Remove
                  </ButtonV2>
                </ButtonContainerV1>
              </CalendarWrapper>
            </StyledModal>
          } */}
        </div>
        
      </Layout>
    );
  }
}

InactiveUsersListView.propTypes = {
  employeeList: PropTypes.array.isRequired,
  showEmployeeDetails: PropTypes.func.isRequired,
  selectedEmployee: PropTypes.any,
  changeOrder: PropTypes.func,
  searchAmigo: PropTypes.bool,
  history: PropTypes.object,
  challenge: PropTypes.object,
  sendFriendRequestPost: PropTypes.func,
  t: PropTypes.func,
  plp:PropTypes.object,
  inactiveUsersList:PropTypes.array,
  locationData:PropTypes.array,
  departmentData:PropTypes.array,
  show: PropTypes.boolean,
  showAll: PropTypes.number,
  inactiveUserCount: PropTypes.number,
  remainingInactiveUser: PropTypes.number,
  updateParentState: PropTypes.func.isRequired,
  fetchInactiveUsersList: PropTypes.func,
  isShowDepartment: PropTypes.number,
  isShowLocation: PropTypes.number,
  daysLeft:PropTypes.bool,
  searchText:PropTypes.string,
  locationText:PropTypes.string,
  departmentText:PropTypes.string,
};

const mapStateToProps = (state) => ({
  sentRequest: state.social.sentRequest
});

export default connect(mapStateToProps, null)(withTranslation()(InactiveUsersListView));